import React, { useContext, useEffect, useState } from 'react'
import { BASE_URL_API } from '../../References/URLs'
import AuthContext from '../../store/auth-context'
import styles from './ManageAccess.module.css'
import { Link, useParams } from 'react-router-dom'
import { FaToggleOff, FaToggleOn } from "react-icons/fa"
import { toast, ToastContainer } from 'react-toastify'
import ActionAccessManagement from '../../Components/StaffManagement/ActionAccessManagement/ActionAccessManagement'
import { BsShieldCheck, BsShieldX, BsPersonBadge } from "react-icons/bs";
import { MdOutlineStorefront, MdOutlineNavigation, MdOutlinePages, MdOutlineTune } from "react-icons/md";

const ManageAccess = () => {
    const authCtx = useContext(AuthContext)
    const loginData = JSON.parse(authCtx?.loginData)
    const { authIdentifier } = useParams()

    const [navigationAccessData, setNavigationAccessData] = useState([])
    const [accessData, setAccessData] = useState([])
    const [storeAccessData, setStoreAccessData] = useState([])
    const [employeeRecords, setEmployeeRecords] = useState([])
    const [isLoadingData, setIsLoadingData] = useState(false)
    const [isUpdatingStatus, setIsUpdatingStatus] = useState(false)
    const [activeTab, setActiveTab] = useState('Store')

    const TABS = [
        { key: "Store", label: "Store Access", icon: MdOutlineStorefront },
        { key: "Navigation", label: "Navigation Access", icon: MdOutlineNavigation },
        { key: "Pages", label: "Pages Access", icon: MdOutlinePages },
        { key: "Features", label: "Features / Actions Access", icon: MdOutlineTune },
    ];

    const getPagesAccessibilityStatus = async () => {
        setIsLoadingData(true)
        const response = await fetch(BASE_URL_API + "getPagesAccessibilityStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authIdentifier,
                    vendorIdentifier: loginData?.partnersData?.vendorIdentifier
                })
            });

        if (!response?.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setAccessData(respo?.response?.allAccess)
                setEmployeeRecords(respo?.response?.employeeRecords)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(respo)
        }
        setIsLoadingData(false)
    }

    const togglePageAccessStatus = async (k) => {
        setIsUpdatingStatus(true)
        const togglePageAccessStatusResponse = await fetch(BASE_URL_API + "togglePageAccessStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authIdentifier,
                    pageUrl: k?.pageUrl
                })
            });

        if (!togglePageAccessStatusResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const togglePageAccessStatusRespo = await togglePageAccessStatusResponse.json()
            if (togglePageAccessStatusRespo.status === "success") {
                toast("Access successfully updated!")
                getPagesAccessibilityStatus()
            } else {
                if (togglePageAccessStatusRespo.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(togglePageAccessStatusRespo)
        }
        setIsUpdatingStatus(false)
    }

    const getStoreAccessibilityStatus = async () => {
        setIsLoadingData(true)
        const getStoreAccessibilityStatusResponse = await fetch(BASE_URL_API + "getStoreAccessibilityStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authIdentifier,
                    vendorIdentifier: loginData?.partnersData?.vendorIdentifier
                })
            });

        if (!getStoreAccessibilityStatusResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const getStoreAccessibilityStatusRespo = await getStoreAccessibilityStatusResponse.json()
            if (getStoreAccessibilityStatusRespo.status === "success") {
                setStoreAccessData(getStoreAccessibilityStatusRespo?.response?.allAccess)
                setEmployeeRecords(getStoreAccessibilityStatusRespo?.response?.employeeRecords)
            } else {
                if (getStoreAccessibilityStatusRespo.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    setStoreAccessData([])
                }
            }
            console.log(getStoreAccessibilityStatusRespo)
        }
        setIsLoadingData(false)
    }

    const toggleStoreAccessStatus = async (k) => {
        setIsUpdatingStatus(true)
        const toggleStoreAccessStatusResponse = await fetch(BASE_URL_API + "toggleStoreAccessStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authIdentifier,
                    storeIdentifier: k?.storeIdentifier
                })
            });

        if (!toggleStoreAccessStatusResponse.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const toggleStoreAccessStatusRespo = await toggleStoreAccessStatusResponse.json()
            if (toggleStoreAccessStatusRespo.status === "success") {
                toast("Store access successfully updated!")
                getStoreAccessibilityStatus()
            } else {
                if (toggleStoreAccessStatusRespo.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    console.log(toggleStoreAccessStatusRespo)
                }
            }
        }
        setIsUpdatingStatus(false)
    }


    const getNavigationAccessibilityStatus = async () => {
        setIsLoadingData(true)
        const response = await fetch(BASE_URL_API + "getNavigationAccessibilityStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authIdentifier,
                    vendorIdentifier: loginData?.partnersData?.vendorIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setNavigationAccessData(respo?.response?.allAccess)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(respo)
        }
        setIsLoadingData(false)
    }

    const toggleNavigationAccessStatus = async (k) => {
        setIsUpdatingStatus(true)
        const response = await fetch(BASE_URL_API + "toggleNavigationAccessStatus",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    authIdentifier: authIdentifier,
                    pageUrl: k?.pageUrl
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                toast("Access successfully updated!")
                getNavigationAccessibilityStatus()
            } else {
                if (respo.message === "tokenExpired") {
                    authCtx.logout()
                } else {

                }
            }
            console.log(respo)
        }
        setIsUpdatingStatus(false)
    }



    useEffect(() => {
        if (activeTab === 'Store') {
            getStoreAccessibilityStatus()
        }
        if (activeTab === 'Navigation') {
            getNavigationAccessibilityStatus()
        }
        if (activeTab === 'Pages') {
            getPagesAccessibilityStatus()
        }
    }, [authIdentifier, activeTab])

    return (
        <div className={styles.mainWrapper}>

            {/* ── Drop this JSX into your render ── */}
            <div className={styles.mainHeader}>

                {/* Left: tab strip */}
                <div className={styles.tabStrip}>
                    {TABS.map(({ key, label, icon: Icon }) => (
                        <button
                            key={key}
                            className={activeTab === key ? styles.tabActive : styles.tab}
                            onClick={() => setActiveTab(key)}
                        >
                            <Icon size={12} />
                            {label}
                        </button>
                    ))}
                </div>

                {/* Right: employee identity card */}
                <div className={styles.identity}>
                    {/* Name + role */}
                    <div className={styles.idCard}>
                        <div className={styles.idAvatar}>
                            {employeeRecords?.displayName?.[0]?.toUpperCase() || "?"}
                        </div>
                        <div className={styles.idMeta}>
                            <span className={styles.idName}>{employeeRecords?.displayName}</span>
                            <span className={styles.idRole}>{employeeRecords?.role?.toLowerCase()}</span>
                        </div>
                    </div>

                    {/* Login status */}
                    <Link
                        to={`/store/employee/${employeeRecords?.staffIdentifier}`}
                        className={styles.loginCard}
                    >
                        {employeeRecords?.isLoginEnabled === "1"
                            ? <BsShieldCheck size={12} className={styles.shieldOn} />
                            : <BsShieldX size={12} className={styles.shieldOff} />
                        }
                        <div className={styles.loginMeta}>
                            <span className={styles.loginUsername}>{employeeRecords?.username || "—"}</span>
                            <span className={employeeRecords?.isLoginEnabled === "1" ? styles.loginOn : styles.loginOff}>
                                {employeeRecords?.isLoginEnabled === "1" ? "Login enabled" : "Login disabled"}
                            </span>
                        </div>
                    </Link>
                </div>

            </div>


            {activeTab === "Store" &&
                <div className={styles.featureTable}>
                    <div className={styles.featureHeader}>
                        <div className={styles.sn}>
                            #
                        </div>
                        <div className={styles.storeDetailsCol}>
                            Store Details
                        </div>
                        <div className={styles.isAccessible}>
                            Status
                        </div>
                    </div>

                    <div className={styles.tableDataWrapper}>
                        {storeAccessData?.map((item, index) => (
                            <div key={index} className={styles.eachFeatureRow}>
                                <div className={styles.sn}>
                                    {index + 1}.
                                </div>
                                <div className={styles.storeDetailsCol}>
                                    <div>
                                        {item?.storeName}
                                    </div>
                                    <div className={styles.storeAddress}>
                                        {item?.storeAddress}
                                    </div>
                                </div>
                                <div className={styles.isAccessible}
                                    onClick={() => toggleStoreAccessStatus(item)}
                                >
                                    {item?.isAccessible === "false" ?
                                        <FaToggleOff color={`#818181`} size={22} />
                                        :
                                        <FaToggleOn color={`#027FFF`} size={22} />
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }

            {activeTab === "Navigation" &&
                <div className={styles.featureTable}>
                    <div className={styles.featureHeader}>
                        <div className={styles.sn}>
                            #
                        </div>
                        <div className={styles.featureLabel}>
                            Navigation
                        </div>
                        <div className={styles.pageUrl}>
                            Route
                        </div>
                        <div className={styles.isAccessible}>
                            Status
                        </div>
                    </div>

                    <div className={styles.tableDataWrapper}>
                        {navigationAccessData?.map((item, index) => (
                            <div key={index} className={styles.eachFeatureRow}>
                                <div className={styles.sn}>
                                    {index + 1}.
                                </div>
                                <div className={styles.featureLabel}>
                                    {item?.featureLabel}
                                </div>
                                <div className={styles.pageUrl}>
                                    {item?.pageUrl}
                                </div>
                                <div className={styles.isAccessible}
                                    onClick={() => toggleNavigationAccessStatus(item)}
                                >
                                    {item?.isAccessible === "false" ?
                                        <FaToggleOff color={`#818181`} size={22} />
                                        :
                                        <FaToggleOn color={`#027FFF`} size={22} />
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }

            {activeTab === "Pages" &&
                <div className={styles.featureTable}>
                    <div className={styles.featureHeader}>
                        <div className={styles.sn}>
                            #
                        </div>
                        <div className={styles.featureLabel}>
                            Feature
                        </div>
                        <div className={styles.pageUrl}>
                            Page Url
                        </div>

                        <div className={styles.isAccessible}>
                            Status
                        </div>
                    </div>

                    <div className={styles.tableDataWrapper}>
                        {accessData?.map((item, index) => (
                            <div key={index} className={styles.eachFeatureRow}>
                                <div className={styles.sn}>
                                    {index + 1}.
                                </div>
                                <div className={styles.featureLabel}>
                                    {item?.featureLabel}
                                </div>
                                <div className={styles.pageUrl}>
                                    {item?.pageUrl}
                                </div>

                                <div className={styles.isAccessible}
                                    onClick={() => togglePageAccessStatus(item)}
                                >
                                    {item?.isAccessible === "false" ?
                                        <FaToggleOff color={`#818181`} size={22} />
                                        :
                                        <FaToggleOn color={`#027FFF`} size={22} />
                                    }
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            }

            {activeTab === "Features" &&
                <ActionAccessManagement storeAccessData={storeAccessData} />
            }

        </div>
    )
}

export default ManageAccess